import { render } from "./RepairPartner.vue?vue&type=template&id=bf88b25c"
import script from "./RepairPartner.vue?vue&type=script&lang=js"
export * from "./RepairPartner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__